import NoInternet from './NoInternet.component';

export default NoInternet;
